<kendo-dialog [title]="dialogTitle" [width]="width" [height]="height">
    <ng-content></ng-content>
</kendo-dialog>